// extracted by mini-css-extract-plugin
export default {"pink":"global_pink__xKdbx","button":"global_button__9jRXp"};